import axios from 'axios'
import qs from 'qs'
import Cookies from "js-cookie";
import { Loading } from "@/components/loading"
import { Message } from 'element-ui'
import { mystorage } from '../utils/myStorage'
import router from "../router";
// const yunpaiUrl = "http://192.168.0.49:8081"; // 本地后台接口地址
// const yunpaiUrl = 'https://ypapi.yuntiankuajing.com';  //后端接口正式地址
// const yunpaiUrl ="https://api-yp-test.yuntiankuajing.com" // 测试环境后台接口地址
let baseurl = '/yunpai_api'

let config = {
  headers: {
    'Authorization': mystorage.get('token'),
    'Accept': 'application/json',
        'Content-Type': 'application/json',
  },
}
// http request 拦截器
axios.interceptors.request.use(
  config => {
    let token = mystorage.get('token')
    if (!token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      router.push('login')
    }
    return config;
  },
  err => {
      return Promise.reject(err);
})

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if(response.status===200){
      
    }else{
      
    }
    return response;
  },
  error => {
    Message({
      type: 'error',
      message: codeMessage[error.response.status]
    });
    Loading.close()
    return Promise.reject(error);
  })
const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网络连接异常，请稍后再试~',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网络连接超时，请稍后再试~',
}
export function getRequest(apiPath, params) {
  let url = baseurl + apiPath
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
      headers: {
        Authorization: mystorage.get('token'),
        Accept: 'application/json',
          'Content-Type': 'application/json',
      },
      params: params
    }).then(
      response => {
        resolve(response.data)
      },
      error => {
        return Promise.reject(error);
      }
    )
  })
}
// json 参数提交
export function postRequest(apiPath, params) {
  let url = baseurl + apiPath
  let config = {
    headers: {
      Authorization: mystorage.get('token'),
      Accept: 'application/json',
        'Content-Type': 'application/json',
    },
  }
  return new Promise((resolve, reject) => {
    axios.post(url, params, config).then(
      response => {
        resolve(response.data)
      },
      error => {
        return Promise.reject(error);
      }
    )
  })
}
// from提交
export function postForm(apiPath, params) {
  let url = baseurl + apiPath
  debugger
  let config = {
    headers: {
      Authorization: mystorage.get('token'),
      Accept: 'application/json',
        'Content-Type': 'application/json',
    },
  }
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(params), config).then(
      response => {
        resolve(response.data)
      },
      error => {
        return Promise.reject(error);
      }
    )
  })
}
export const download = (urls) => {
  let name = urls
  // let url = window.URL.createObjectURL(new Blob(config.url + urls)); //创建下载链接
  let link = document.createElement('a') // 创建a标签
  link.style.display = 'none' // 将a标签隐藏
  link.href = urls // 给a标签添加下载链接(本地服务器)
  // link.href = '/' + urls // 给a标签添加下载链接(可本地localhost)
  link.setAttribute('download', `${name}`) // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
  document.body.appendChild(link)
  link.click() // 执行a标签
}

// json格式 参数  json 
export function exportRequest(apiPath, params, fileName, fileType, successCallback, errorCallback) {
  fileType = fileType || 'xls';
  fileName = fileName || '导出文件';
  let url = baseurl + apiPath
  let config = {
    headers: {
      Authorization: mystorage.get('token'),
      Accept: 'application/json',
        'Content-Type': 'application/json',
      // responseType: 'blob',
    },
  }
  return new Promise((resolve, reject) => {
    axios.post(url, params, config).then(res => {
      if (res.status === 200) {
        // download(res.data.data)//download方法，rs.msg为后端返回的url
        // console.log(res)
        let url = res.data.data;
        // let url = window.URL.createObjectURL(res.data.data);
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', `${fileName}.${fileType}`);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          if (successCallback) successCallback(res)
        }, 800);
      } else {
        if (errorCallback) errorCallback(res.code, res.msg)
      }
    })
  })
}

/**
 * 请求结果处理
 * @param axiosRequest
 * @param successCallback
 * @param errorCallback
 */
function thenResponse(axiosRequest, successCallback, errorCallback) {
  axiosRequest.then((res) => {
    if (res.status === 200) {
      res = res.data
      if (res.success) {
        if (successCallback) successCallback(res)
      } else {
        if (errorCallback) errorCallback(res.code, res.msg)
      }
    }
  }).catch((error) => {
    if (errorCallback) errorCallback(-1, error.message)
  })
}
export const HttpService = {
  get: function (url, param) {
    return getRequest(url, param)
  },
  post: function (url, param) {
    return postForm(url, param)
  },
  postForm: function (url, param) {
    return postRequest(url, param)
  },
  exportRequest: function (url, param, fileName, fileType, successCallback, errorCallback) {
    return exportRequest(url, param, fileName, fileType, successCallback, errorCallback)
  },
  baseurl
}



// WEBPACK FOOTER //
// ./src/http/HttpService.js